import FontBody1 from '../../fonts/font-body1/font-body1';
import { FONT_VARIANT } from '../../fonts/font-props';
import { IconProps } from '../../icons/icon-props-interface';
import Icon from '../../icons/icon/icon';
import RoundLoader, { RoundLoaderType } from '../../loaders/round-loader/round-loader';
import { BUTTON_VARIANTS } from '../button-variants';
import './button.scss';


export interface IButtonProps {
    onClick?: () => void,
    disabled?: boolean,
    variant?: BUTTON_VARIANTS,
    isLoading?: boolean,
    hasLoader?: boolean,
    text?: string,
    leftIcon?: React.FC<IconProps>,
    rightIcon?: React.FC<IconProps>,
}

export const Button: React.FC<IButtonProps> = ({ 
    onClick = () => { },
    disabled = false,
    variant = BUTTON_VARIANTS.Primary,
    isLoading = false,
    hasLoader = false,
    text,
    leftIcon,
    rightIcon,
}) => {
    const loaderType = [BUTTON_VARIANTS.Primary].includes(variant) ? RoundLoaderType.Light : RoundLoaderType.Dark;

    return (
        <button className={`button ${variant} ${isLoading && 'isLoading'} ${hasLoader && 'hasLoader'}`} onClick={onClick} disabled={disabled || (hasLoader && isLoading)}>
            {(hasLoader && isLoading) && <div className="loader-container"><RoundLoader type={loaderType} /></div>}
            {leftIcon && <Icon Component={leftIcon} disabled={disabled} />}
            <FontBody1 variant={[FONT_VARIANT.BOLD, FONT_VARIANT.UPPERCASE]}>{text}</FontBody1>
            {rightIcon && <Icon Component={rightIcon} disabled={disabled} />}
        </button>
    );

}
